module.exports = __webpack_public_path__ + "static/zyj-101d3c75a17369f7c93ef53429e1e02b.png";